import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-8 md:py-10 px-4 bg-gradient-to-br from-success-green to-emerald-700 text-white" data-id="element-133">
      <div className="max-w-3xl mx-auto" data-id="element-134">
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="flex flex-col md:flex-row items-center gap-4 md:gap-6" data-id="element-135">
          {/* Icon */}
          <div className="shrink-0 relative" data-id="element-136">
            <div className="absolute inset-0 bg-white/30 blur-xl rounded-full" data-id="element-137"></div>
            <div className="relative bg-white text-success-green p-3 rounded-full shadow-xl" data-id="element-138">
              <ShieldCheck size={36} strokeWidth={2.2} data-id="element-139" />
            </div>
          </div>

          {/* Content */}
          <div className="flex-1 text-center md:text-left" data-id="element-140">
            <div className="inline-block bg-white text-success-green font-black px-3 py-0.5 rounded-full text-[10px] md:text-xs mb-2 tracking-widest shadow-md" data-id="element-141">
              7 DÍAS GARANTÍA TOTAL
            </div>
            <h2 className="font-heading text-lg md:text-2xl font-extrabold mb-1 leading-tight" data-id="element-142">
              Probalo o te devolvemos el{' '}
              <span className="text-accent-gold" data-id="element-143">100%</span>
            </h2>
            <p className="text-xs md:text-sm text-green-50 font-medium leading-snug" data-id="element-144">
              Sin preguntas, sin formularios, sin drama.{' '}
              <span className="text-green-200" data-id="element-145">(Devoluciones &lt;1%)</span>
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}